import React, { useState } from 'react';
import { Button, Segment } from 'tea-component';

import SvgIcon from '@/pages/home/components/SvgIcon';

import GameList from './GameList';

import './RelatedGame.scss';
import LoadingCommon from '../../LoadingCommon';
import NoDataCommon from '../../NoDataCommon';
import { useIntl } from 'umi';

// 参考使用这里的 src/pages/opinion/pages/competitor/components/ComparisonCard/Components/AddCompare/index.tsx
import EditFollowingModal from './EditFollowingModal';

export default function RelatedGame(props: any) {
  const { formatMessage } = useIntl(); 
  const [editModalVisible, setEditModalVisible] = useState(false);
  
  const {
    search = '',
    recentList = [],
    gameList = [],
    hasRecentList = false,
    hasGameListTitle = true,
    gameListTitle,
    hasGameTypeChange = true,
    gameListStyle = {},
    recentListStyle = {},

    gameListLoading = true,
    rencentListLoading = true,
    isCollect,

    // recommendedList = [],
    handleCollect,
    allGameList = [], 
    emptyDescText = "There's no data under the current search conditions", 
    handleEmptyCollectDescTextClick, 
    emptyCollectDescText = (
      <>
        <p style={{ marginBottom: 5 }}>
          {formatMessage({
            id: 'There are no following games.',
          })}
        </p>

        <p
          onClick={() => setEditModalVisible(true)}
          dangerouslySetInnerHTML={{
            __html: formatMessage({
              id: 'Please click <a>[Edit]</a> to follow games.',
            }),
          }}
        ></p>
      </>
    ),

    isFollowing = false,
  } = props;


  const list: any = {
    mobile: [],
    pc: [],
    console: [],
  };

  for (let index = 0; index < gameList?.length; index++) {
    const item = gameList[index];
    const { entity_type } = item;
    list[entity_type].push(item);
  }

  const gameTypeList = [
    { text: formatMessage({ id: 'All' }), value: 'all' },
    {
      text: (
        <>
          <SvgIcon className="all-game-icon" type="other-icon" />
          {list.mobile.length}
        </>
      ),
      icon: 'other-icon',
      value: 'mobile',
    },
    {
      text: (
        <>
          <SvgIcon className="all-game-icon" type="monitor" />
          {list.pc.length}
        </>
      ),
      icon: 'monitor',
      value: 'pc',
    },
    {
      text: (
        <>
          <SvgIcon className="all-game-icon" type="merit" />
          {list.console.length}
        </>
      ),
      icon: 'merit',
      value: 'console',
    },
  ];

  const [gameType, setGameType] = useState('all');

  const renderGameList = (
    loading: boolean,
    list: any,
    isCollectList = false,
  ) => {
    const renderList = list.filter((item: any) => {
      if (gameType === 'all') return true;
      return item.entity_type === gameType;
    });
    return (
      <>
        {loading ? (
          <LoadingCommon
            status="loading"
            style={{
              height: 200,
            }}
          ></LoadingCommon>
        ) : renderList?.length === 0 ? (
          <>
            <NoDataCommon
              hasDesc
              hasImg={false}
              emptyDescText={
                isCollectList ? emptyCollectDescText : emptyDescText
              }
              style={{
                height: 80,
              }}
            ></NoDataCommon>
          </>
        ) : (
          <GameList
            list={renderList}
            isCollect={isCollect}
            handleCollect={handleCollect}
            searchText={search}
          />
        )}
        {/* {recommendedList?.length > 0 && (
          <div className="drawer-gamelistbox-block dbo-search-recommendation">
            <div className="drawer-title-flex drawer-title-flex-follow">
              <div className="drawer-title-text">
                {formatMessage({ id: 'Search Recommendation' })}
              </div>
            </div>
            <GameList
              list={recommendedList}
              isCollect={isCollect}
              handleCollect={handleCollect}
            />
          </div>
        )} */}
      </>
    );
  };

  return (
    <>
      {hasGameTypeChange && (
        <div className="drawer-gamefilter">
          <Segment
            value={gameType.toString()}
            onChange={setGameType}
            options={gameTypeList}
          />
        </div>
      )}

      <div className="drawer-gamelistbox" style={{ ...recentListStyle }}>
        {hasRecentList && (
          <div className="drawer-gamelistbox-block">
            <div className="drawer-title-flex drawer-title-flex-follow">
              <div className="drawer-title-text">
                {formatMessage({ id: 'Recent Viewed' })}
              </div>
            </div>
            {renderGameList(rencentListLoading, recentList)}
          </div>
        )}

        <div
          className={`drawer-gamelistbox-block `}
          style={{ ...gameListStyle }}
        >
          {hasGameListTitle && (
            <div className="drawer-title-flex drawer-title-flex-follow">
              <div className="drawer-title-text">
                {gameListTitle || formatMessage({ id: 'Game List' })} (
                {gameList?.length || 0})
              </div>
              <Button
                type="weak"
                onClick={() => {
                  setEditModalVisible(true);
                }}
                className="exit-btn ns-btn--iconBorder"
              >
                <SvgIcon className="exit-btn-icon" type="pencil-m" />
                {formatMessage({ id: 'Edit' })}
              </Button>
            </div>
          )}
          {renderGameList(gameListLoading, gameList, isFollowing)}
        </div>
      </div>

      {editModalVisible && (
        <EditFollowingModal
          visible={editModalVisible}
          close={() => {
            setEditModalVisible(false);
          }}
          confirm={(collectList: string[]) => {
            setEditModalVisible(false);
            props.handleCollectListUpdate?.(collectList);
          }}
          source={allGameList}
          target={gameList}
        />
      )}
    </>
  );
}
